// extracted by mini-css-extract-plugin
module.exports = {"Root":"BaseIcon_Root__2Dca0","IconPanel":"BaseIcon_IconPanel__VmRvY","Label":"BaseIcon_Label__6O4iA"};